export default "__VITE_ASSET__B8B9xwbs__"